import { T_Question } from "../../T_Question"

export function test_mobu21() {
    var q_list = [];
    var q;
    
  const mark = ' (Markieren sie die  am ehesten zutreffende Möglichkeit.)';

  q = new T_Question();
  q.qid = "1";
  q.title = "Anzahl";
  q.text = "Wie viele Smartphones sind aktuell weltweit im Gebrauch?" + mark;
  q.ac("1 Milliarde");
  q.ac("1.5 Milliarden");
  q.ac("6 Milliaren");
  q.ac("*4,5 Milliarden");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "2";
  q.title = "Jahresumsatz"
  q.text = "Wie hoch schätzen sie den weltweiten jährlichen Umsatz mit Smartphones?" + mark;
  q.ac("100 Milliarden USD");
  q.ac("*400 Milliarden USD");
  q.ac("900 Millionen USD");
  q.ac("4000 Milliarden USD");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "3";
  q.title = "Jahresumsatz in DE"
  q.text = "Wie hoch schätzen sie den jährlichen Umsatz mit Smartphones in Deutschland?" + mark;
  q.ac("*10 Milliarden EURO");
  q.ac("100 Milliarden EURO");
  q.ac("800 Millionen EURO");
  q.ac("100 Milliarden EURO");
  q.max_selections = -1;
  q_list.push(q);

  
  q = new T_Question();
  q.qid = "4";
  q.title = "Weltweiter Absatz"
  q.text = "Wie hoch schätzen sie den weltweiten Absatz von Smartphones im Jahr 2020?" + mark;
  q.ac("500 Millionen Geräte ");
  q.ac("3 Milliarden Geräte");
  q.ac("1 Million Geräte");
  q.ac("*1 Milliarde Geräte");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "5";
  q.title = "Absatz in DE"
  q.text = "Wie hoch schätzen sie den Absatz von Smartphones in Deutschland im Jahr 2020?" + mark;
  q.ac("40 Millionen Geräte");
  q.ac("2 Millionen Geräte");
  q.ac("*20 Millionen");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "6";
  q.title = "Durchschnittspreis in DE"
  q.text = "Wie hoch schätzen sie den Durchschnittspreis eines Smartphones im Konsumentenmarkt in Deutschland im Jahr 2020? " + mark;
  q.ac("350 Euro");
  q.ac("*500 Euro");
  q.ac("650 Euro");
  q.max_selections = -1;
  q_list.push(q);


  q = new T_Question();
  q.qid = "2";
  q.title = "Weltweiter Absatz nach Quartalen"
  q.text = "In welchem Quartal werden die meisten Smartphones verkauft?" + mark;
  q.ac("Q1");
  q.ac("Q2");
  q.ac("Q3");
  q.ac("*Q4");
  q.max_selections = -1;
  q_list.push(q);


  q = new T_Question();
  q.qid = "2";
  q.title = "Top 3 Modelle in DE"
  q.text = "Die Top-3 Einzelmodelle, die im April 2021 in Deutschland verkauft wurden, stammen ...?" + mark;
  q.ac("alle von Samsung");
  q.ac("*alle von Apple");
  q.ac("von zwei verschiedenen Herstellern");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "2";
  q.title = "Betriebssysteme"
  q.text = "Welche Aussagen über die Markanteile der Betriebssysteme (am Absatz) ist für das Jahr 2020 korrekt?" + mark;
  q.ac("*Zwei Betriebssysteme teilen sich den Markt auf.");
  q.ac("Zwei Betriebssysteme teilen sich den Markt mit jeweils gleichen Marktanteilen auf.");
  q.ac("Drei Betriebssysteme teilen sich den Markt mit jeweils gleichen Marktanteilen auf.");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "2";
  q.title = "Anzahl der Nutzer weltweit"
  q.text = "In welcher der folgenden Regionen vermuten sie die größte Anzahl an Samrtphone Nutzern?" + mark;
  q.ac("*Asien-Pazifik");
  q.ac("Europa");
  q.ac("Naher Osten und Afrika");
  q.ac("Latein-Amerika");
  q.ac("Nord-Amerika");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "2";
  q.title = "Anzahl der Nutzer in DE"
  q.text = "Wie groß ist die Anzahl an Smartphone-Nutzern in Deutschland im Jahr 2020?" + mark;
  q.ac("40 Millionen");
  q.ac("50 Millionen");
  q.ac("*60 Millionnen");
  q.ac("70 Millionnen");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "2";
  q.title = "Anzahl sehr junger Nutzer in DE"
  q.text = "Wie hoch schätzen sie den Anteil an Smartphone-Nutzern in Deutschland (im Jahr 2019) in der Altersgruppe von 12-13 Jahren?" + mark;
  q.ac("75%");
  q.ac("80%");
  q.ac("85%");
  q.ac("90%");
  q.ac("*95%");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "2";
  q.title = "Beliebte Funktionen für junge Nutzer"
  q.text = "Welche Funktion ist die beliebteste Funktionen unter Teenagern in DE (2019)?" + mark;
  q.ac("Soziale Netzwerke");
  q.ac("*Musik hören");
  q.ac("Internet surfen");
  q.ac("Soziale Netzwerke");
  q.ac("Mail");
  q.ac("Telefonieren");
  q.ac("Kamera");
  q.max_selections = -1;
  q_list.push(q);

  q = new T_Question();
  q.qid = "2";
  q.title = "Beliebte Funktionen für Senioren"
  q.text = "Welche Funktion ist die beliebteste Funktionen unter Senioren (65+) in DE (2020)?" + mark;
  q.ac("Soziale Netzwerke");
  q.ac("Musik hören");
  q.ac("Internet surfen");
  q.ac("Soziale Netzwerke");
  q.ac("Mail");
  q.ac("*Telefonieren");
  q.ac("Kamera");
  q.max_selections = -1;
  q_list.push(q);

  return {
    id: "test_mobu21",
    questions: q_list,
    long_name: "Smartphones im Jahr 2021",
    moodle_category:"Smartphones"
  }
  
}
